import React, { useCallback, useMemo, useState } from "react";
import { CiSettings } from "react-icons/ci";
import { toast } from "react-toastify";
import DataTable from "../components/DataTable";
import Layout from "../components/Layout";
import Modal from "../components/Modal";
import ParameterButtons from "../components/ParameterButtons";
import { grids } from "../constants/grids";
import { useStateContext } from "../contexts/ContextProvider";
import { useLazyGetFieldsByFormQuery } from "../redux/formService";
import {
  useLazyGetParamsQuery,
  usePostParamMutation,
  useUpdateParamMutation,
} from "../redux/paramService";
import { filterDataByDate } from "../utils";

const GestionUsagers = () => {
  const [showForm, setShowForm] = useState(false);
  const [filter, setFilter] = useState();
  const [selectedParams, setSelectedParams] = useState();
  const [showTable, setShowTable] = useState(false);
  const [selected, setSelected] = useState();
  const [selectedGrid, setSelectedGrid] = useState();
  const [fields, setFields] = useState();
  const [category, setCategory] = useState();
  const [forms, setForms] = useState();
  const [types, setTypes] = useState();
  const [selectedType, setSelectedType] = useState();

  const { currentColor } = useStateContext();
  // const { data, isLoading } = useGetRedevablesQuery({ page: 1, size: 20 });
  const [getFields, { data: fieldsData, isLoading: isFieldsLoading }] =
    useLazyGetFieldsByFormQuery();
  const [getParams, { data: paramsData, isLoading: isParamsLoading }] =
    useLazyGetParamsQuery();
  const [postParams] = usePostParamMutation();
  const [updateParams] = useUpdateParamMutation();

  const handleShowModal = useCallback((props) => {
    setSelected({ id: props?.id, ...props?.attributes });
    setShowForm(true);
  }, []);

  const fetchFieldsAndParams = async (endpoint, fieldId) => {
    const paramsResponse = await getParams({ endpoint, page: 1, size: 100 });
    const fieldsResponse = await getFields(fieldId).unwrap();
    setFields(fieldsResponse?.data || []);
    return paramsResponse?.data?.data || [];
  };

  const selectParameter = async (e) => {
    setSelectedParams(e);
    setShowTable(false);
    console.log("parameter", e);
    const grid = grids[e]?.grid;
    if (!grid) return;

    switch (e) {
      case "categorie redevances":
        setCategory(await fetchFieldsAndParams("categories", 1));
        break;
      case "bureau":
        setCategory(await fetchFieldsAndParams("bureaus", 20));
        break;
      case "type usager":
        setTypes(await fetchFieldsAndParams("types", 3));
        break;
      case "systeme":
        await fetchFieldsAndParams("systemes", 6);
        break;
      case "type redevance":
        const fetchedFields = await fetchFieldsAndParams("types", 4);
        if (fetchedFields.length > 0) {
          const updatedFields = [...fetchedFields];
          if (category?.length > 0) {
            const categorieField = updatedFields.find(
              (item) => item.attributes.field_id === "category"
            );
            if (categorieField) {
              categorieField.attributes.options = category;
            } else {
              updatedFields.push({
                attributes: {
                  field_id: "category",
                  label: "Catégorie",
                  type: "select",
                  options: category,
                },
              });
            }
          }
          if (forms?.length > 0) {
            const formField = updatedFields.find(
              (item) => item.attributes.field_id === "form"
            );
            if (formField) {
              formField.attributes.options = forms;
            } else {
              updatedFields.push({
                attributes: {
                  field_id: "form",
                  label: "Formulaire",
                  type: "select",
                  options: forms,
                },
              });
            }
          }
          setFields(updatedFields);
        }
        break;
      default:
        break;
    }

    setSelectedGrid(grid);
    setShowTable(true);
  };

  const selectTypes = (e) => {
    setSelectedType(e);
    setShowTable(false);
  };

  const sendData = (data) => {
    const endpointMap = {
      "categorie redevances": "categories",
      "type usager": "types",
      "type redevance": "types",
      systeme: "systemes",
      bureau: "bureaus",
    };

    const endpoint = endpointMap[selectedParams];
    data.endpoint = endpoint;

    const action = selected
      ? updateParams({ ...data, endpoint })
      : postParams(data);

    action
      .then(() => {
        setShowForm(false);
        getParams({ endpoint, page: 1, size: 20 });
        toast.success(
          selected ? "Mise à jour réussie" : "Ajout du type réussie"
        );
      })
      .catch(() =>
        toast.error(
          selected
            ? "Une erreur s'est produite pendant la mise à jour"
            : "Une erreur s'est produite, veuillez réessayer"
        )
      );
  };

  const filteredData = useMemo(
    () => filterDataByDate(paramsData?.data, filter),
    [paramsData?.data, filter]
  );

  // useEffect(() => {
  //   let isMounted = true;

  //   const fetchCategoriesAndTypes = async () => {
  //     const fetchData = async (endpoint) => {
  //       const result = [];
  //       await getParams({ endpoint, page: 1, size: 100 }).then((res) => {
  //         if (isMounted) {
  //           res?.data?.data?.forEach((item) => {
  //             if (item.attributes.name) {
  //               result.push({ label: item.attributes.name, value: item.id });
  //             }
  //           });
  //         }
  //       });
  //       return result;
  //     };

  //     setCategory(await fetchData("categories"));
  //     setTypes(await fetchData("types"));
  //     setForms(await fetchData("forms"));
  //   };

  //   fetchCategoriesAndTypes();

  //   return () => {
  //     isMounted = false;
  //   };
  // }, [getParams]);

  return (
    <Layout title="Paramètre du système">
      <div className="w-full flex flex-col items-center">
        {!isFieldsLoading && (
          <Modal
            showForm={showForm}
            send={sendData}
            setShowForm={setShowForm}
            fields={fields}
            selectedData={selected}
            selectType={selectTypes}
          />
        )}
        <ParameterButtons selectParameter={selectParameter} />

        <h1 className="text-center first-letter:capitalize text-2xl font-bold border-b-2 border-slate-300 py-2">
          {selectedParams}
        </h1>
        {selectedParams && fieldsData && (
          <div className="flex w-full space-x-4 justify-center items-center my-4">
            <button
              onClick={() => {
                setShowForm(!showForm);
                setSelected(null);
              }}
              className="text-white w-32 space-x-2 text-3xl flex bg-primary hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              type="button">
              <CiSettings />
              <p className="text-base">Ajouter</p>
            </button>
          </div>
        )}
        {isParamsLoading ? (
          <p>Chargement des données...</p>
        ) : (
          showTable && (
            <DataTable
              data={filteredData || paramsData?.data}
              grid={selectedGrid}
              handleShowModal={handleShowModal}
            />
          )
        )}
      </div>
    </Layout>
  );
};

export default GestionUsagers;
